import { OwnUpBottomModal } from '@rategravity/own-up-component-library';
import React from 'react';
import { RulesValidation } from '../rules-validation';

export const RulesValidationModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => (
  <OwnUpBottomModal title="" open={open} onClose={onClose}>
    <RulesValidation />
  </OwnUpBottomModal>
);
